import type { ACLAction } from './lib/acl';
import { AdminLayout } from './app/components/AdminLayout';
import { RequireAuth } from './app/components/RequireAuth';
import { AppContextProvider } from './appcontext';
import { APP_TYPE } from './constants';

type AppWrapperProps = {
  appType: APP_TYPE;
  menu: NonNullable<React.ReactNode>;
  children: NonNullable<React.ReactNode>;
  resource?: string;
  action?: ACLAction | ACLAction[];
};

const AppWrapper: React.FC<AppWrapperProps> = ({ appType, menu, children, resource, action }) => (
  <AppContextProvider appType={appType}>
    <RequireAuth resource={resource} action={action}>
      <AdminLayout menu={menu}>{children}</AdminLayout>
    </RequireAuth>
  </AppContextProvider>
);

export default AppWrapper;
